export const MOMENT_FORMAT = "DD-MM-YYYY";
export const YEAR_RANGE = ((start, end) =>
  Array.from({ length: end - start }, (v, k) => k + start))(
  1900,
  2075
).reverse();
export const CAREER_PAGINATION_PAGE_SIZE = 10;